import React from 'react';
import { Copy } from 'lucide-react';
import { notification } from 'antd';

interface JsonFormatterProps {
	data: any;
	className?: string;
}

export const JsonFormatter: React.FC<JsonFormatterProps> = ({ data, className }) => {
	const formattedJson = JSON.stringify(data, null, 2);

	const handleCopy = () => {
		navigator.clipboard.writeText(formattedJson);
		notification.success({
			message: 'Copied to clipboard',
		});
	};

	// Function to format JSON with syntax highlighting
	const formatJsonWithSyntaxHighlighting = (json: string) => {
		// Replace special characters to avoid HTML issues
		const escaped = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

		// Add syntax highlighting with regex
		return escaped.replace(
			/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
			(match) => {
				let cls = 'text-amber-400'; // number - amber
				if (/^"/.test(match)) {
					if (/:$/.test(match)) {
						cls = 'text-blue-400'; // key - blue
					} else {
						cls = 'text-green-400'; // string - green
					}
				} else if (/true|false/.test(match)) {
					cls = 'text-purple-400'; // boolean - purple
				} else if (/null/.test(match)) {
					cls = 'text-red-400'; // null - red
				}
				return `<span class="${cls}">${match}</span>`;
			},
		);
	};

	return (
		<div className={['relative rounded-lg overflow-hidden', className].join(' ')}>
			<div className="absolute top-2 right-2 z-10">
				<button
					onClick={handleCopy}
					className="bg-slate-700/80 hover:bg-slate-600 text-white p-1.5 rounded-md transition-all"
					title="Copy JSON"
				>
					<Copy size={16} />
				</button>
			</div>
			<pre className="p-4 bg-gray-900 text-gray-200 overflow-x-auto rounded-lg text-sm">
				<code
					dangerouslySetInnerHTML={{ __html: formatJsonWithSyntaxHighlighting(formattedJson) }}
				/>
			</pre>
		</div>
	);
};
